$(document).ready(function () {
  function isMobile() {
    return window.innerWidth <= 1200; // Adjust breakpoint as needed
  }

  $("#toogle-btn").click(function () {
    if (isMobile()) {
      $("#toogle-btn").toggleClass("nav-active");
      $("body").toggleClass("nav-open");
    }
  });

  $(".overlay").click(function () {
    if (isMobile()) {
      $("#toogle-btn").removeClass("nav-active");
      $("body").removeClass("nav-open");
    }
  });

  $(".menu-list li a").click(function () {
    if (isMobile()) {
      $("#toogle-btn").removeClass("nav-active");
      $("body").removeClass("nav-open");
    }
  });

  var swiper = new Swiper(".castswiper", {
    slidesPerView: 5,
    spaceBetween: 8,
    // autoplay: {
    //     delay: 1500,
    //     disableOnInteraction: false,
    //   },
    // Responsive breakpoints
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      567: {
        slidesPerView: 2,
      },
      767: {
        slidesPerView: 3,
      },
      1199: {
        slidesPerView: 4,
      },
      1399: {
        slidesPerView: 5,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
    var swiper = new Swiper(".castswiper-img", {
    slidesPerView: 5,
    spaceBetween: 8,
    // autoplay: {
    //     delay: 1500,
    //     disableOnInteraction: false,
    //   },
    // Responsive breakpoints
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      567: {
        slidesPerView: 2,
      },
      767: {
        slidesPerView: 3,
      },
      1199: {
        slidesPerView: 4,
      },
      1399: {
        slidesPerView: 6,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  document.addEventListener("DOMContentLoaded", function () {
    const menuLinks = document.querySelectorAll(".menu-link");
    const header = document.querySelector(".header-god-father");
    const sections = Array.from(menuLinks)
      .map((link) => {
        const targetId = link.getAttribute("href").substring(1);
        return document.getElementById(targetId);
      })
      .filter((section) => section !== null); // Filter out null sections

    menuLinks.forEach((link) => {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent default anchor behavior

        const targetId = this.getAttribute("href").substring(1);
        const targetSection = document.getElementById(targetId);

        if (targetSection) {
          // Smooth scrolling to the section
          window.scrollTo({
            top: targetSection.offsetTop - header.offsetHeight,
            behavior: "smooth",
          });

          // Remove 'active' class from all menu links
          menuLinks.forEach((link) => link.classList.remove("active"));

          // Add 'active' class to the clicked menu item
          this.classList.add("active");
        }
      });
    });

    // Function to check active menu on scroll
    function updateActiveMenu() {
      let scrollPosition = window.scrollY + header.offsetHeight + 10;
      let lastSection = sections.length ? sections[sections.length - 1] : null;
      let lastSectionReached =
        lastSection &&
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 10;

      if (lastSectionReached) {
        // If user is at the bottom and there is a valid last section, activate its menu item
        menuLinks.forEach((link) => link.classList.remove("active"));
        const lastMenuLink = document.querySelector(
          `.menu-link[href="#${lastSection.id}"]`
        );
        if (lastMenuLink) lastMenuLink.classList.add("active");
      } else {
        sections.forEach((section, index) => {
          if (section) {
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;

            if (
              scrollPosition >= sectionTop &&
              scrollPosition < sectionTop + sectionHeight
            ) {
              menuLinks.forEach((link) => link.classList.remove("active"));
              menuLinks[index].classList.add("active");
            }
          }
        });
      }
    }

    // Listen for scroll event
    window.addEventListener("scroll", updateActiveMenu);
  });

  document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector(".header-god-father");

    window.addEventListener("scroll", function () {
      if (window.scrollY > 50) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    });
  });

  // $( "#toogle-btn" ).click(function() {
  //   $("#toogle-btn").toggleClass('toogle-menu-open')
  //   $("body").toggleClass('nav-open');
  // });

  $(".overlay").click(function () {
    $("#toogle-btn").removeClass("toogle-menu-open"); // Close the menu
    $("body").removeClass("nav-open"); // Remove body class
    $(".overlay").fadeOut(); // Hide overlay
  });
});
